export default "__VITE_ASSET__1b3cda97__"